import {timeFormat} from 'd3-time-format';

function measure (_val) {
  if (typeof _val === 'string') {
    this.__attrs__.measures.push({field: _val, op: 'sum'});
  } else if (typeof _val === 'object') {
    if ('format' in _val && typeof _val.format === 'string') _val.format = timeFormat(_val.format);
    this.__attrs__.measures.push(_val);
  }
  return this;
}

export default measure;


// WEBPACK FOOTER //
// ./layouts/default/measure.js